// not from crezu-helpers for zero dependencies
const getCookie = (cname) => {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let c of ca) {
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return null
}

const setCookie = (cname, cvalue, exdays) => {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}
const getURLParameter = (sParam, url) => {
  const sPageURL = !url ? window.location.search.substring(1) : url
  const sURLVariables = sPageURL.split('&')
  const firstUrl = sPageURL.split('?')
  const decoder = (param) => {
    try {
      return decodeURIComponent(param)
    } catch (e) {
      console.log(e)
      return param
    }
  }
  for (const i of sURLVariables) {
    const sParameterName = i.split('=')
    if (sParameterName[0] === sParam) {
      return decoder(sParameterName[1])
    }
  }
  for (const i of firstUrl) {
    const sParameterName = i.split('=')
    if (sParameterName[0] === sParam) {
      return decoder(sParameterName[1].replace(/&\w+/gi, ''))
    }
  }
  return null
}

export const useFakeBacker = (sitename, locale) => {
  const offerwallDomainByCountry = {
    // es: 'dinero123.es',
    // mx: 'prestamo52.mx',
    // ph: 'fastloans24.ph',
    // co: 'prestamos365.co',
    // ua: 'fastkredit.com.ua',
    // kz: 'tengefast.kz',
    // vn: 'vaypoint.vn', // temporary disabled
    // ro: 'baniinsta.ro',
    // pl: 'fastcredits.pl',
  }
  const backerOfferwall = offerwallDomainByCountry[locale]

  let backAllowed = true

  const validateFakeBacker = async () => {
    const sameGEO = getURLParameter('without_geocheck') || (await checkGEO(locale))
    if (!sameGEO || !isCampaign()) backAllowed = false
  }

  const pushStateGoogle = () => {
    if (!backerOfferwall) return

    let searchStr = window.location.search
    if (!searchStr && Object.hasOwn(window, 'sbjs'))
      searchStr = `?utm_source=${window.sbjs.get.current.src}&utm_medium=${window.sbjs.get.current.mdm}&utm_campaign=${window.sbjs.get.current.cmp}&utm_content=${window.sbjs.get.current.cnt}&utm_term=${window.sbjs.get.current.trm}`
    let offerwallAddress = `https://${offerwallDomainByCountry[locale]}/`

    window.history.pushState({ action: 'fake' }, '')
    window.history.pushState({ action: 'fake' }, '')
    window.addEventListener('popstate', function (e) {
      console.log('popstate', e.state, e.state.action)
      if (e.state && e.state.action === 'fake' && backAllowed) {
        window.history.pushState({ action: 'google' }, '')

        let address
        const showGoogle =
          getCookie('backAlreadyShowed') ||
          getURLParameter('utm_source') === 'google' ||
          (window.sbjs && window.sbjs.get.current.src === 'google')
        if (showGoogle) {
          address = offerwallAddress + `google/${searchStr ? `${searchStr}&` : '?'}sub2=${sitename}_google`
          setCookie('backAlreadyShowed', '', 1)
        } else {
          address = offerwallAddress + `${searchStr ? `${searchStr}&` : '?'}sub2=${sitename}_browser-back`
          // it's not a mistake, we rewrite default sub2 of offerwall with ext2 value
          setCookie('backAlreadyShowed', 'true', 1)
        }
        window.location.assign(address)
      } else {
        console.log('backAllowed', backAllowed)
      }
    })
  }

  const checkGEO = async (normalizedLocale) => {
    if (normalizedLocale === 'ua') return true // exclude UA from geocheck (high percentage of errors 25%)
    let isoCode = 'error'
    try {
      const req = await fetch('https://workers.crezu.net/geoip/')
      const res = await req.json()
      isoCode = res.iso_code
    } catch (e) {
      console.log(e)
    }

    return isoCode.toLowerCase() === normalizedLocale
  }

  const isCampaign = () => {
    try {
      return !!(
        getURLParameter('sub2') ||
        sessionStorage.getItem('querySub2') ||
        getURLParameter('utm_campaign') ||
        (window.sbjs && window.sbjs.get.current.cmp)
      )
    } catch (e) {
      console.log(e)
      return true
    }
  }

  return { pushStateGoogle, validateFakeBacker }
}



//////////////////
// WEBPACK FOOTER
// ../common/composables/useFakeBacker.js
// module id = 312
// module chunks = 0